
export const ANIMATION_PHASES = {
  HIDDEN: 'HIDDEN',           
  ENTERING: 'ENTERING',       
  VISIBLE: 'VISIBLE',        
  EXITING: 'EXITING'          
};

export const FRAME_RATIOS = {
  ENTRY_RATIO: 20 / 100,
  
  STAY_RATIO: 40 / 100,
  
  EXIT_RATIO: 20 / 100,
  
  TOTAL_ACTIVE_RATIO: 80 / 100
};

export const HIGHLIGHT_ZONE = {
  ACTIVE_PERCENTAGE: 0.80,   
  PADDING_START: 0.10,       
  PADDING_END: 0.10           
};

export const SLIDE_CONFIG = {
  RIGHT_SLIDE_DISTANCE: 350,  
  
  LEFT_SLIDE_DISTANCE: 280,   
};

export const SPEC_ITEMS_CONFIG = [
  {
    key: 'model',
    label: 'Model',
    iconType: 'car-front',
    iconPosition: 'left',   
  },
  {
    key: 'power',
    label: 'Power',
    iconType: 'lightning',
    iconPosition: 'right',  
  },
  {
    key: 'make',
    label: 'Make',
    iconType: 'car-suv',
    iconPosition: 'left',   
  },
  {
    key: 'mileage',
    label: 'Milege',        
    iconType: 'speedometer',
    iconPosition: 'right',  
  },
  {
    key: 'price',
    label: 'Price',
    iconType: 'price-tag',
    iconPosition: 'left',   
  },
  {
    key: 'fuel',
    label: 'Fuel',
    iconType: 'fuel-pump',
    iconPosition: 'right',  
  }
];


export const STYLES = {
  // Icon circle (matches CSS .iconCircle)
  ICON_SIZE: 75,
  ICON_SIZE_LARGE: 85,
  ICON_SIZE_MEDIUM: 65,
  ICON_SIZE_SMALL: 55,
  ICON_SIZE_MOBILE: 45,
  
  // Colors
  PRIMARY_BLUE: '#4A90D9',
  PRIMARY_BLUE_DARK: '#357ABD',
  PILL_BACKGROUND: 'rgba(245, 245, 245, 0.95)',
  TEXT_PRIMARY: '#1a1a1a',
  TEXT_SECONDARY: '#4a4a4a',
  SNAKE_LINE_COLOR: 'rgba(100, 149, 237, 0.5)',
  
  // Dimensions (matches CSS .pillContainer)
  PILL_BORDER_RADIUS: 40,
  PILL_PADDING_X: 32,
  PILL_PADDING_Y: 16,

  SNAKE_STROKE_WIDTH: 2,
  SNAKE_START_OFFSET_X: 85, // % from left where snake starts
  SNAKE_START_OFFSET_Y: 6,  // % from top where snake starts
};

export const Z_INDEX = {
  SNAKE_LINE: 45,
  SPEC_ITEMS: 50,
  ICONS: 51
};


export const isHighlightEnabled = (options = {}) => {
  // Check passed options
  if (options.enabled !== undefined) {
    return options.enabled;
  }
  
  // Check if vehicle data has highlight flag
  if (options.vehicleData?.showHighlights !== undefined) {
    return options.vehicleData.showHighlights;
  }
  
  // Default: disabled until explicitly enabled
  return false;
};

export const EASING = {
  // Linear - constant speed (PRIMARY)
  linear: (t) => t,
  
  // Ease out cubic - fast start, slow end (optional)
  easeOutCubic: (t) => 1 - Math.pow(1 - t, 3),
  
  // Ease in out cubic - smooth (optional)
  easeInOutCubic: (t) => t < 0.5 
    ? 4 * t * t * t 
    : 1 - Math.pow(-2 * t + 2, 3) / 2,
};

export const PHASE_DISTRIBUTION = {
  ENTERING: { start: 0, end: 20 / 80 },
  VISIBLE: { start: 20 / 80, end: (20 + 40) / 80 },
  EXITING: { start: (20 + 40) / 80, end: 1.0 }
};

const constantsExport = {
  ANIMATION_PHASES,
  FRAME_RATIOS,
  HIGHLIGHT_ZONE,
  SLIDE_CONFIG,
  SPEC_ITEMS_CONFIG,
  STYLES,
  Z_INDEX,
  isHighlightEnabled,
  EASING,
  PHASE_DISTRIBUTION
};

export default constantsExport;
